import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { fetchMe, getToken, AUTH_EVENT } from '../services/auth.js';

const AuthContext = createContext({ user: null, ready: false });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    // Re-read the session on mount and whenever the token is set or cleared.
    const sync = () => {
      if (!getToken()) {
        setUser(null);
        setReady(true);
        return;
      }
      setReady(false);
      fetchMe()
        .then((u) => alive && setUser(u))
        .catch(() => {
          localStorage.removeItem('drill.jwt');
          if (alive) setUser(null);
        })
        .finally(() => alive && setReady(true));
    };
    sync();
    window.addEventListener(AUTH_EVENT, sync);
    return () => {
      alive = false;
      window.removeEventListener(AUTH_EVENT, sync);
    };
  }, []);

  const value = useMemo(() => ({ user, ready }), [user, ready]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

// useAppAuth exposes the shared auth state for the whole application.
export function useAppAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAppAuth must be used within an AuthProvider');
  return ctx;
}

export default AuthContext;
